import React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { Box, Button, IconButton, Modal, Stack, Typography } from '@mui/material'
import { isEmpty } from 'lodash'
import { FormProvider, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { CountriesList } from '../../../../utils/Data'

import { FormAutocompleteMultiSelect } from '../../../index'
import {
  StyledFormControl,
  StyledModalContainer,
} from './StyledComponents/StyledNewUboResidencyModal'

export const NewUboResidencyModal: React.FC<{
  isOpen: boolean
  editData: { i: number; countries: string[] } | undefined
  onClose: () => void
  onSubmit: (value: string[]) => void
}> = ({ isOpen, editData, onClose, onSubmit }) => {
  const { t } = useTranslation()

  const methods = useForm({ mode: 'onChange' })

  const { register, watch, reset } = methods

  const uboResidencyName = 'residencies'
  register(uboResidencyName)
  const value = watch(uboResidencyName)

  const handleResetModal = () => {
    reset({
      [uboResidencyName]: [],
    })
  }

  return (
    <Modal open={isOpen} onClose={onClose}>
      <StyledModalContainer>
        <FormProvider {...methods}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            p={3}
            sx={{
              '& > svg': {
                marginRight: 15,
              },
            }}
          >
            <Typography variant="h4" fontWeight="bold" data-test="autotest-newUboResidencyTitle">
              {t('uboResidency', 'UBO Residency')}
            </Typography>
            <IconButton onClick={onClose}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <Box px={3} overflow="auto">
            <StyledFormControl>
              <FormAutocompleteMultiSelect
                defaultValue={!!editData && editData.countries}
                name={uboResidencyName}
                label={t('countries', 'Countries')}
                data={CountriesList}
                data-test="uboResidency"
                isForModal
              />
            </StyledFormControl>
          </Box>

          <Stack
            justifyContent="flex-end"
            rowGap={1}
            columnGap={3}
            sx={{
              flexDirection: { xs: 'column-reverse', sm: 'row' },
              padding: (theme) => theme.spacing(4, 3),
              '& .MuiButton-root': {
                minWidth: (theme) => theme.spacing(6.25),
              },
            }}
          >
            <Button
              variant="contained"
              disableElevation
              color="inherit"
              data-test="autotest-uboResidencyCancel"
              onClick={() => {
                onClose()
                handleResetModal()
              }}
            >
              {t('cancel', 'Cancel')}
            </Button>
            <Button
              variant="contained"
              type="button"
              color="primary"
              disabled={isEmpty(value)}
              disableElevation
              data-test="newUboResidencyModalSubmit"
              onClick={() => {
                onSubmit(value)
                handleResetModal()
              }}
            >
              {t('submit', 'Submit')}
            </Button>
          </Stack>
        </FormProvider>
      </StyledModalContainer>
    </Modal>
  )
}
